import script from "./ColoredProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ColoredProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./ColoredProgressBar.vue?vue&type=style&index=0&id=5f242c12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f242c12"]])

export default __exports__